export const GrayBox = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div className={`bg-neutral-100 dark:bg-neutral-700 p-4 ${className}`}>{children}</div>
);
